// extracted by mini-css-extract-plugin
export var infoItem = "_qc-2";
export var title = "_qc-0";
export var value = "_qc-1";